import axios from 'axios';



(() => {

  // カレンダー要素
  const scheduleCalendar = document.getElementById('scheduleCalendar');

  // カレンダー選択ナビゲーション
  const topContainer    = document.getElementById('cal-nav-top');
  const bottomContainer = document.getElementById('cal-nav-bottom')

  // ---- 状態管理 ----
  const state = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    yearRange: []
  };

  // ---- テンプレートを複製して上下に挿入 ----
  const tpl = document.getElementById('cal-nav-tpl');
  const navTemplate = tpl.content.cloneNode(true); // content全体をコピー
  const topNav = tpl.content.firstElementChild.cloneNode(true);
  const middleNav = tpl.content.cloneNode(true); // ←別方式でも可
  const navHtml = tpl.content; // テンプレートの元を参照

  // テンプレート内の構造が複数あるので、<template>内の子要素すべてをまとめてクローン
  function createNav() {
    const fragment = document.createDocumentFragment();
    tpl.content.childNodes.forEach(node => fragment.appendChild(node.cloneNode(true)));
    return fragment;
  }

  const topNavFragment = createNav();
  const bottomNavFragment = createNav();

  topContainer.appendChild(topNavFragment);
  bottomContainer.appendChild(bottomNavFragment);

  // 現在年から過去と未来の年を配列で出力する
  function getYearRange(past = 2, future = 2) {
    const y = new Date().getFullYear();
    return Array.from({ length: past + future + 1 }, (_, i) => y - past + i);
  }



  // ---- 選択肢を埋める ----
  function fillSelects(root) {
    const ySel = root.querySelector('select[name="year"]');
    const mSel = root.querySelector('select[name="month"]');

    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    // グローバルな状態に格納して他でも使えるようにする
    state.yearRange = getYearRange();

    state.yearRange.forEach( y => {
      const opt = new Option(`${y}`, y, false, y === currentYear);
      ySel.add(opt);
    });

    for (let m = 1; m <= 12; m++) {
      const opt = new Option(`${m}`, m, false, m === currentMonth);
      mSel.add(opt);
    }
  }

  fillSelects(topContainer);
  fillSelects(bottomContainer);



  // ---- イベントをバインド ----
  function bindNav(root) {
    const prevBtn = root.querySelector('[data-prev="true"]');
    const nextBtn = root.querySelector('[data-next="true"]');
    const yearSel = root.querySelector('select[name="year"]');
    const monthSel = root.querySelector('select[name="month"]');

    prevBtn.addEventListener('click', () => stepMonth(-1));
    nextBtn.addEventListener('click', () => stepMonth(+1));
    yearSel.addEventListener('change', () => setYM(+yearSel.value, state.month));
    monthSel.addEventListener('change', () => setYM(state.year, +monthSel.value));
  }

  bindNav(topContainer);
  bindNav(bottomContainer);



  // ---- 状態変更・同期 ----
  function stepMonth(delta) {
    let y = state.year;
    let m = state.month + delta;
    // 月の繰り上げ・繰り下げ
    if (m < 1) { m = 12; y--; }
    if (m > 12) { m = 1; y++; }
    // ▼ ここで yearRange の範囲内に制限
    const minYear = Math.min(...state.yearRange);
    const maxYear = Math.max(...state.yearRange);
    // 範囲外なら state 変更しない
    if (y < minYear || y > maxYear) return;
    setYM(y, m);
  }

  function setYM(y, m) {
    if (y === state.year && m === state.month) return;
    state.year = y;
    state.month = m;
    syncSelects();
    fetchCalendar();
  }

  function syncSelects() {
    [topContainer, bottomContainer].forEach(root => {
      const ySel = root.querySelector('select[name="year"]');
      const mSel = root.querySelector('select[name="month"]');
      const prevBtn = root.querySelector('[data-prev="true"]');
      const nextBtn = root.querySelector('[data-next="true"]');

      ySel.value = state.year;
      mSel.value = state.month;

      const minYear = Math.min(...state.yearRange);
      const maxYear = Math.max(...state.yearRange);

      prevBtn.disabled = state.year === minYear && state.month === 1;
      nextBtn.disabled = state.year === maxYear && state.month === 12;
    });
  }

  async function fetchCalendar() {
    const res = await axios.get(`./calendar?y=${state.year}&m=${state.month}`);
    scheduleCalendar.innerHTML = res.data;
  }

  fetchCalendar();



  // ---------- ---------- ---------- ---------- ---------- 試合情報・チケット

  // オブザーバインスタンスを作成
  const observer = new MutationObserver((mutations) => {
    // 試合情報・チケットボタンを取得します
    const triggers = scheduleCalendar.querySelectorAll('[data-modal-game]');
    if (!triggers || triggers.length === 0) return;

    for (const button of triggers) {
      // クリックイベント
      button.onclick = (e) => {
        e.stopPropagation();
        const uuid = e.target.dataset.modalGame;
        fetchMatch(uuid);
      };

    }
  });

  // オブザーバの監視を開始
  observer.observe(scheduleCalendar, {
    childList: true,
    characterData: true,
    subtree: true
  });

  // モーダルを閉じるイベント
  function close()
  {
    const modal   = document.getElementById('modalGame');
    const inner   = modal.querySelector('.modal-inner');
    const closers = modal.querySelectorAll('[data-close]');
    closers.forEach( el => {
      el.onclick = (e) => {
        e.stopPropagation();
        // 自分自身をクリックした場合のみ閉じる
        if (e.currentTarget === el) modal.remove();
      }
    });
    // モーダル内側をクリックしたときは閉じない
    modal.onclick = (e) => {
      e.stopPropagation();
      if (!inner.contains(e.target)) modal.remove();
    }
  }

  async function fetchMatch($_uuid) {
    const res = await axios.get(`./match?u=${$_uuid}`);
    scheduleCalendar.insertAdjacentHTML('afterbegin', res.data);
    close();
  }



})();
